var React = require('react');

function TickCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 14.6667C11.6667 14.6667 14.6667 11.6667 14.6667 8.00004C14.6667 4.33337 11.6667 1.33337 8 1.33337C4.33333 1.33337 1.33333 4.33337 1.33333 8.00004C1.33333 11.6667 4.33333 14.6667 8 14.6667Z","fill":"transparent","key":0}),React.createElement("path",{"d":"M5.16667 7.99995L7.05333 9.88661L10.8333 6.11328","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

TickCircle.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 16 16"};

module.exports = TickCircle;

TickCircle.default = TickCircle;
